module.exports = __webpack_public_path__ + "static/media/grayWireTransfer.c4f81fe6.svg";